/**
 * Bomet Municipal Business Database Management System
 * Copyright (c) 2024 Bett Kipngetich Nicholas
 * All rights reserved.
 */
import React from 'react';
import { BrowserRouter, Routes, Route, Navigate, NavLink, useLocation } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { AuthProvider, useAuth } from './context/AuthContext';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import BusinessList from './pages/BusinessList';
import BusinessForm from './pages/BusinessForm';
import ImportData from './pages/ImportData';
import PublicDirectory from './pages/PublicDirectory';

function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div style={{display:'flex',justifyContent:'center',alignItems:'center',height:'100vh'}}>Loading...</div>;
  return user ? children : <Navigate to="/login" />;
}

function Layout({ children }) {
  const { user, logout } = useAuth();
  const location = useLocation();
  return (
    <div className="app-layout">
      <aside className="sidebar">
        <div className="sidebar-header">
          <h2>Bomet Municipal</h2>
          <p>Business Management System</p>
        </div>
        <nav>
          <NavLink to="/" className={location.pathname === '/' ? 'active' : ''}>📊 Dashboard</NavLink>
          <NavLink to="/businesses" className={location.pathname.startsWith('/businesses') ? 'active' : ''}>🏪 Businesses</NavLink>
          <NavLink to="/businesses/new" className={location.pathname === '/businesses/new' ? 'active' : ''}>➕ Add Business</NavLink>
          <NavLink to="/import" className={location.pathname === '/import' ? 'active' : ''}>📁 Import CSV</NavLink>
        </nav>
        <div className="sidebar-footer">
          <div style={{fontSize:'12px',marginBottom:'8px',opacity:0.7}}>{user?.first_name || user?.username}</div>
          <button onClick={logout}>🚪 Logout</button>
        </div>
      </aside>
      <main className="main-content">{children}</main>
    </div>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-right" />
        <Routes>
          <Route path="/directory" element={<PublicDirectory />} />
          <Route path="/login" element={<Login />} />
          <Route path="/" element={<ProtectedRoute><Layout><Dashboard /></Layout></ProtectedRoute>} />
          <Route path="/businesses" element={<ProtectedRoute><Layout><BusinessList /></Layout></ProtectedRoute>} />
          <Route path="/businesses/new" element={<ProtectedRoute><Layout><BusinessForm /></Layout></ProtectedRoute>} />
          <Route path="/businesses/:id/edit" element={<ProtectedRoute><Layout><BusinessForm /></Layout></ProtectedRoute>} />
          <Route path="/import" element={<ProtectedRoute><Layout><ImportData /></Layout></ProtectedRoute>} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
